"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzContainer__Wrapper",
  componentId: "sc-1jozjh5-0"
})(["\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  padding-left: 20px;\n  padding-right: 20px;\n  ", "\n\n\n  &, & * {\n    box-sizing: border-box;\n  }\n"], function (props) {
  return props.size !== "fluid" ? "\n    @media (min-width: 576px){\n      max-width: " + (props.size === "extra" ? 540 : props.size === "big" ? 540 : props.size === "medium" ? 540 : 450) + "px;\n    }\n    @media (min-width: 768px){\n      max-width: " + (props.size === "extra" ? 720 : props.size === "big" ? 720 : props.size === "medium" ? 720 : 450) + "px;\n    }\n    @media (min-width: 992px){\n      max-width: " + (props.size === "extra" ? 960 : props.size === "big" ? 960 : props.size === "medium" ? 850 : 450) + "px;\n    }\n    @media (min-width: 1200px){\n      max-width: " + (props.size === "extra" ? 1140 : props.size === "big" ? 1140 : props.size === "medium" ? 850 : 450) + "px;\n    }\n    @media (min-width: 1600px){\n      max-width: " + (props.size === "extra" ? 1400 : props.size === "big" ? 1140 : props.size === "medium" ? 850 : 450) + "px;\n    }\n  " : null;
});

var OzContainer = function OzContainer(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? "big" : _ref$size,
      children = _ref.children;
  return __jsx(Wrapper, {
    size: size
  }, children);
};

var _default = OzContainer;
exports.default = _default;